import React, { useState } from 'react';
import { connect } from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import { getRents } from '../../store/rentsLld/actions';
import LldRentsTable from './LldRentsTable';
import ValidationModal from '../Layout/ValidationModal';
import { getDayFirstSecondeDate, getDayLastSecondeDate } from '../../services/DateService';
function a11yProps(index) {
  return {
    id: `lld-rent-${index}`,
    key: `lld-rent-${index}`,
    'aria-controls': `lld-rent-tab-${index}`,
  };
}

const LldRentTabs = (props) => {
  const {authUser, roles, selectedSite, rentsLld, getRents} = props;
  const [tabValue, setTabValue] = useState(0);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalHandleValidate, setModalHandleValidate] = useState(() => {});
  const [modalTitle, setModalTitle] = useState('');
  const [modalText, setModalText] = useState('');

  const openDialog = (title, text, action) => {
    setModalTitle(title);
    setModalText(text);
    setModalHandleValidate(action);
    setModalVisible(true);
  }

  const modalHandleClose = () => {
    setModalVisible(false);
  }

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (authUser && roles) {
    if (!rentsLld.content && !rentsLld.pending && !rentsLld.error) {
      getRents(authUser.ma, roles[props.authUser.uid], null, selectedSite);
    }
  }

  const role = (authUser && roles && roles[authUser.uid]) || ROLE_USER;
  let todayEndRents = [];
  let needToBeClosedRents = [];
  if (rentsLld.content && rentsLld.content.rents) {
    let start = getDayFirstSecondeDate();
    let end = getDayLastSecondeDate();
    todayEndRents = rentsLld.content.rents.filter(elem => {
      return elem.long_rent_end_date > (start.getTime() / 1000)
        && elem.long_rent_end_date < (end.getTime() / 1000);
    })
    needToBeClosedRents = rentsLld.content.rents.filter(elem => {
      return elem.long_rent_end_date < (end.getTime() / 1000)
        && elem.end_date === null;
    })
  }
  return (
    <React.Fragment>
      <Tabs value={tabValue} onChange={handleChange}>
        <Tab label="Mes retours du jour" {...a11yProps(0)} />
        <Tab label="Toutes les locations" {...a11yProps(1)} />
        <Tab label="Disponibilité par vélo" {...a11yProps(2)} />
        {role === ROLE_ADMIN && <Tab label="En attente de cloture" {...a11yProps(3)} />}
      </Tabs>
      <div
        role="tabpanel"
        hidden={tabValue !== 0}
        id={`lld-rent-tabpanel-0`}
        aria-labelledby={`lld-rent-tab-0`}
      >
        {todayEndRents && <LldRentsTable
          rents={todayEndRents}
          pending={rentsLld.pending}
          openDialog={openDialog}
        />}
      </div>
      <div
        role="tabpanel"
        hidden={tabValue !== 1}
        id={`lld-rent-tabpanel-1`}
        aria-labelledby={`lld-rent-tab-1`}
      >
        {rentsLld.content && <LldRentsTable
          rents={rentsLld.content.rents}
          pending={rentsLld.pending}
          openDialog={openDialog}
          />}
      </div>
      <div
        role="tabpanel"
        hidden={tabValue !== 2}
        id={`lld-rent-tabpanel-2`}
        aria-labelledby={`lld-rent-tab-2`}
      >
        <p>Disponible prochainement</p>
      </div>
      {role === ROLE_ADMIN && <div
        role="tabpanel"
        hidden={tabValue !== 3}
        id={`lld-rent-tabpanel-3`}
        aria-labelledby={`lld-rent-tab-3`}
      >
        {needToBeClosedRents && <LldRentsTable
          rents={needToBeClosedRents}
          pending={rentsLld.pending}
          openDialog={openDialog}
        />}
      </div>}
      <ValidationModal
        visible={modalVisible}
        handleValidate={() => modalHandleValidate()}
        handleClose={modalHandleClose}
        title={modalTitle}
        text={modalText}
        validationText={'Oui, supprimer'}
        closeText={'Non, annuler'}
        />
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  authUser: state.users.authUser,
  roles: state.roles.content,
  selectedSite: state.sitesLld.selected,
  rentsLld : state.rentsLld
});

export default connect(mapStateToProps, { getRents })(LldRentTabs);



// WEBPACK FOOTER //
// ./src/components/LldRent/LldRentTabs.jsx